import React, { useEffect, useRef, useState } from "react";

export default function CursorGlow() {
  const target = useRef({ x: -200, y: -200 });
  const current = useRef({ x: -200, y: -200 });
  const [pos, setPos] = useState({ x: -200, y: -200 });
  const [visible, setVisible] = useState(false);
  const raf = useRef(null);

  useEffect(() => {
    const handle = (e) => {
      target.current = { x: e.clientX, y: e.clientY };
      setVisible(true);
    };
    const leave = () => setVisible(false);
    window.addEventListener("mousemove", handle);
    window.addEventListener("mouseleave", leave);

    const tick = () => {
      // smooth lerp toward the cursor for a softer, more premium trailing glow
      current.current.x += (target.current.x - current.current.x) * 0.12;
      current.current.y += (target.current.y - current.current.y) * 0.12;
      setPos({ x: current.current.x, y: current.current.y });
      raf.current = requestAnimationFrame(tick);
    };
    raf.current = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", handle);
      window.removeEventListener("mouseleave", leave);
      if (raf.current) cancelAnimationFrame(raf.current);
    };
  }, []);

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed z-[9999] hidden md:block"
      style={{
        top: pos.y - 240,
        left: pos.x - 240,
        width: 480,
        height: 480,
        background:
          "radial-gradient(circle, rgba(201,162,39,0.16) 0%, rgba(16,185,129,0.09) 32%, transparent 62%)",
        filter: "blur(36px)",
        opacity: visible ? 1 : 0,
        transition: "opacity .4s ease",
      }}
    />
  );
}
